module.exports = __webpack_public_path__ + "img/Azerbaijan.17c629a1.svg";